/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import VehTypeActionButton from './vehTypeActionButton';
import AgGridTable from '../../agGridComponent/agGridTable';
import moment from 'moment'
import { FEATURES } from '../../../utils/constants';

function VehicleTypeTable(props) {
    const [vehTypes, setvehTypes] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        let vehicleTypeData = {
            "userId": userId,
            "customerNumber": customerNo
        }

        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vehicleTypeMaster/`, vehicleTypeData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setvehTypes(response.data.resultSet)
            setisLoaded(true)
        }))
            .catch(error => {
                console.log(error);
                setisLoaded(true);
            })

       
    }, [])

    
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    if (vehTypes.length === 0 && isLoaded === false) {
        return (
            <LoadingPlaceholder />
        )
    } else if (vehTypes.length === 0) {
        return (
            <Segment className="m-2">
                <center> <Header>NO Record(s) Found</Header></center>
            </Segment>
        )
    } else {

        let columnDefs = [
            { headerName: 'Vehicle Type Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Type Name', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created Date', field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
        ]
        let rowData = []
        vehTypes.map((object, i) => {
            console.log(object,'obj')
            let temp = {}
            temp.code = object.vehicleTypeCode
            temp.name = object.vehicleType
            temp.cby = object.createdBy == null ? null : object.createdBy
            temp.id = object.vehicleTypeId
            temp.cdate = moment(object.createdOn).format('DD-MM-yyyy')
            temp.uby = object.updatedBy == null ? null : object.updatedBy 
            temp.udate =  object.updatedOn == null ? null : moment(object.updatedOn).format('DD-MM-yyyy')
            temp.customerNo = object.customerNo
            rowData[i] = temp
        })
        return (
            <React.Fragment >
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    actionButton={VehTypeActionButton}
                    reload={getUpdate}
                    link="/add-vehicletype"
                    hiddenNewPopupBtn={true}
                    BaseUrl={props}
                    hiddenImportPopupBtn={true}
                    titleBarTitle="Vehicle Type"
                    handleSearch={props.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }

}

export default VehicleTypeTable
